/** Case types catalogue and the Case settings page (ADR-0065). */
export default {
  en: {
    settings: {
      open: "Case types and calendar",
      title: "Case types and calendar",
      purpose: "The kinds of case your organisation works and its working calendar.",
      tabTypes: "Case types",
    },
    intro: "Each kind of case has a plain name, the team that works it, how fast to respond and the information a new case must have.",
    new: "New case type",
    edit: "Edit case type",
    readOnly: "Only case administrators and team admins can change case types.",
    empty: "No case types yet. Without them, new cases are “General cases”.",
    hours_one: "Respond within {{n}} working hour",
    hours_other: "Respond within {{n}} working hours",
    noTarget: "No response target",
    switchedOff: "{{name}} switched off",
    switchedOn: "{{name}} switched on",
    switchOff: "Switch off",
    switchOn: "Switch on",
    active: "In use",
    off: "Switched off",
    deleted: "Case type deleted",
    saved: "{{name}} saved",
    deleteConfirm: "Delete {{name}}? This is only possible while no case uses it.",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    editNamed: "Edit {{name}}",
    deleteNamed: "Delete {{name}}",
    col: { name: "Name", queue: "Team (queue)", respond: "Respond within", fields: "Information asked", status: "Status", actions: "Actions" },
    form: {
      label: "Name",
      description: "What it is for",
      queue: "Team that works it",
      queueHelp: "New cases go to this queue.",
      respond: "Respond within (working hours)",
      priority: "Usual priority",
      classification: "Usual sensitivity",
      active: "In use",
      fields: "Information a new case needs",
      fieldsHelp: "People creating a case are asked for these values. Required ones must be filled in.",
      fieldAr: "Name (Arabic)",
      fieldEn: "Name (English)",
      kind: "Kind",
      required: "Required",
      removeField: "Remove {{name}}",
      addField: "Add information",
      key: "Key",
      fieldKey: "Field key",
      needed: "Information this kind of case needs",
      missing: "Still needed: {{fields}}.",
    },
    kind: { text: "Text", number: "Number", date: "Date" },
    issues: {
      key_invalid: "Give the case type an English or Arabic name.",
      key_taken: "A case type with this name already exists.",
      label_required: "Enter a name in Arabic or English.",
      hours_invalid: "The response time must be more than zero hours.",
      field_key_invalid: "Every piece of information needs a name.",
      field_key_duplicate: "Two pieces of information have the same name.",
      field_label_required: "Every piece of information needs a name in Arabic or English.",
    },
    // Stream D (G-camp-cs-13): "Open a case" in the Builder.
    step: {
      type: "Type of case",
      pick: "Pick a type of case",
      fields: "Information this type of case keeps",
      fieldsHelp: "Type a value, or type {{brace}} to take one from an earlier step.",
      none: "Your organisation has no case types yet, so this step can't open a case.",
      unknown: "‘{{type}}’ isn't one of your organisation's case types. Pick one from the list.",
      manage: "Add or change case types in Cases › Case types",
      failed: "The case types couldn't be loaded. You can still type the type of case.",
    },
  },
  ar: {
    settings: {
      open: "أنواع الحالات والتقويم",
      title: "أنواع الحالات والتقويم",
      purpose: "أنواع الحالات التي تعالجها جهتك وتقويم العمل.",
      tabTypes: "أنواع الحالات",
    },
    intro: "لكل نوع من الحالات اسم واضح، والفريق الذي يعالجه، ومدة الرد، والمعلومات التي تحتاجها الحالة الجديدة.",
    new: "نوع حالة جديد",
    edit: "تعديل نوع الحالة",
    readOnly: "لا يغيّر أنواع الحالات إلا مسؤولو الحالات ومسؤولو الفريق.",
    empty: "لا توجد أنواع حالات بعد. بدونها تكون الحالات الجديدة «حالات عامة».",
    hours_zero: "الرد خلال {{n}} ساعة عمل",
    hours_one: "الرد خلال ساعة عمل واحدة",
    hours_two: "الرد خلال ساعتي عمل",
    hours_few: "الرد خلال {{n}} ساعات عمل",
    hours_many: "الرد خلال {{n}} ساعة عمل",
    hours_other: "الرد خلال {{n}} ساعة عمل",
    noTarget: "بدون مدة رد محددة",
    switchedOff: "أُوقف {{name}}",
    switchedOn: "فُعِّل {{name}}",
    switchOff: "إيقاف",
    switchOn: "تفعيل",
    active: "مستخدم",
    off: "موقوف",
    deleted: "حُذف نوع الحالة",
    saved: "حُفظ {{name}}",
    deleteConfirm: "حذف {{name}}؟ لا يمكن ذلك إلا إذا لم تستخدمه أي حالة.",
    delete: "حذف",
    cancel: "إلغاء",
    save: "حفظ",
    editNamed: "تعديل {{name}}",
    deleteNamed: "حذف {{name}}",
    col: { name: "الاسم", queue: "الفريق (قائمة العمل)", respond: "الرد خلال", fields: "المعلومات المطلوبة", status: "الحالة", actions: "الإجراءات" },
    form: {
      label: "الاسم",
      description: "الغرض منه",
      queue: "الفريق الذي يعالجه",
      queueHelp: "تذهب الحالات الجديدة إلى هذه القائمة.",
      respond: "الرد خلال (ساعات العمل)",
      priority: "الأولوية المعتادة",
      classification: "درجة الحساسية المعتادة",
      active: "مستخدم",
      fields: "المعلومات التي تحتاجها الحالة الجديدة",
      fieldsHelp: "يُطلب من منشئ الحالة إدخال هذه القيم، ويجب تعبئة المطلوب منها.",
      fieldAr: "الاسم (بالعربية)",
      fieldEn: "الاسم (بالإنجليزية)",
      kind: "النوع",
      required: "مطلوب",
      removeField: "إزالة {{name}}",
      addField: "إضافة معلومة",
      key: "المفتاح",
      fieldKey: "مفتاح الحقل",
      needed: "المعلومات التي يحتاجها هذا النوع من الحالات",
      missing: "ما زال مطلوبًا: {{fields}}.",
    },
    kind: { text: "نص", number: "رقم", date: "تاريخ" },
    issues: {
      key_invalid: "أعطِ نوع الحالة اسمًا بالعربية أو الإنجليزية.",
      key_taken: "يوجد نوع حالة بهذا الاسم بالفعل.",
      label_required: "أدخل اسمًا بالعربية أو الإنجليزية.",
      hours_invalid: "يجب أن تكون مدة الرد أكثر من صفر ساعة.",
      field_key_invalid: "كل معلومة تحتاج إلى اسم.",
      field_key_duplicate: "معلومتان تحملان الاسم نفسه.",
      field_label_required: "كل معلومة تحتاج إلى اسم بالعربية أو الإنجليزية.",
    },
    // Stream D (G-camp-cs-13): "Open a case" in the Builder.
    step: {
      type: "نوع القضية",
      pick: "اختر نوع القضية",
      fields: "المعلومات التي يحفظها هذا النوع من القضايا",
      fieldsHelp: "اكتب قيمة، أو اكتب {{brace}} لتأخذها من خطوة سابقة.",
      none: "لا توجد أنواع قضايا في مؤسستك بعد، لذا لا تستطيع هذه الخطوة فتح قضية.",
      unknown: "‘{{type}}’ ليس من أنواع القضايا في مؤسستك. اختر نوعًا من القائمة.",
      manage: "أضف أنواع القضايا أو غيّرها من القضايا › أنواع القضايا",
      failed: "تعذّر تحميل أنواع القضايا. ما زال بإمكانك كتابة نوع القضية.",
    },
  },
};
